"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGISTRY_TYPE_URLS = exports.BTC_STAKER = exports.REWARD_GAUGE_KEY_BTC_DELEGATION = void 0;
exports.REWARD_GAUGE_KEY_BTC_DELEGATION = "BTC_STAKER";
exports.BTC_STAKER = "btc_staker";
exports.REGISTRY_TYPE_URLS = {
    MsgCreateBTCDelegation: "/babylon.btcstaking.v1.MsgCreateBTCDelegation",
    MsgBtcStakeExpand: "/babylon.btcstaking.v1.MsgBtcStakeExpand",
    MsgWithdrawRewardForBTCStaking: "/babylon.incentive.MsgWithdrawReward",
    MsgStakeBABY: "/babylon.epoching.v1.MsgWrappedDelegate",
    MsgUnstakeBABY: "/babylon.epoching.v1.MsgWrappedUndelegate",
    MsgWithdrawRewardForBABYStaking: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
};
//# sourceMappingURL=constants.js.map